import { render } from "./FatturazioneGas.vue?vue&type=template&id=6c49b2d8&scoped=true"
import script from "./FatturazioneGas.vue?vue&type=script&lang=js"
export * from "./FatturazioneGas.vue?vue&type=script&lang=js"

import "./FatturazioneGas.vue?vue&type=style&index=0&id=6c49b2d8&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c49b2d8"]])

export default __exports__